import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ScrollText, Eye } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { customerMenu } from "@/config/menus";
import { PageHeader } from "@/components/KpiCard";
import { Button } from "@/components/ui/button";
import { StatusPill, inr, LoadingScreen, EmptyState } from "@/components/common";

export default function Contracts() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/contracts/mine").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <DashboardShell menu={customerMenu} title="Contracts">
      <PageHeader title="Your Contracts" subtitle="Digital contracts with your security agencies." />
      {!rows ? <LoadingScreen /> : rows.length === 0 ? (
        <EmptyState icon={ScrollText} title="No contracts yet" hint="Accept a quotation to generate your first digital contract." />
      ) : (
        <div className="bg-white border border-navy-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[700px]">
            <thead className="bg-navy-50 text-navy-500 text-xs uppercase">
              <tr><th className="text-left p-3">Agency</th><th className="text-left p-3">Location</th><th className="p-3">Guards</th><th className="p-3">Monthly</th><th className="p-3">Duration</th><th className="p-3">Status</th><th className="p-3"></th></tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} className="border-t border-navy-100" data-testid={`contract-row-${c.id}`}>
                  <td className="p-3 font-medium text-navy-900">{c.agency_name}</td>
                  <td className="p-3 text-navy-600">{c.service_location}</td>
                  <td className="p-3 text-center text-navy-600">{c.num_guards}</td>
                  <td className="p-3 text-center font-semibold text-navy-900">{inr(c.monthly_charges)}</td>
                  <td className="p-3 text-center text-navy-600">{c.contract_duration_months}mo</td>
                  <td className="p-3 text-center"><StatusPill status={c.status} /></td>
                  <td className="p-3 text-right"><Button size="sm" variant="outline" className="border-navy-300" onClick={() => navigate(`/contracts/${c.id}`)} data-testid={`view-contract-${c.id}`}><Eye size={15} /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardShell>
  );
}
